
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

// const data = [
//     {
//         "filled": {
//             "teamName": "team 2",
//             "filedUser": 4,
//             "unFilledUser": 5
//         },
       
//         "assignTo": 9
//     },
//     {
//       "filled": {
//           "teamName": "team 2",
//           "filedUser": 4,
//           "unFilledUser": 5
//       },
      
//       "assignTo": 9
//   }
// ]



export default function TeamAnalytics({data}) {
  if (!data || data.length === 0 || !data[0].questions || data[0].questions.length === 0) {
    return null; // or render some error message
  }
  console.log(data)
  const transformData = (data) => {
    return data.map((item, index) => ({
      name: `Team ${index + 1}`,
      filled: item.filled.filedUser,
      unfilled: item.filled.unFilledUser
    }));
  };
  
  const chartData = transformData(data);
  console.log(chartData)
  return (
  
    <BarChart
    width={600} 
    height={400}
    data={chartData}
    margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }}
  >
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="name" />
    <YAxis />
    <Tooltip />
    <Legend />
    <Bar dataKey="filled" fill="#8884d8" />
    <Bar dataKey="unfilled" fill="#82ca9d" />
  </BarChart>
  
  );
}
